<template>
    <div >
      <modal
        :title="`Send to Marketplace`"
        @close-request="reinitializeModal();"
        closable
        >
        <table-element
          :title="$t('OrderCurrent.modal.selected_orders')"
          :fields="fieldsObj"
          :arrOfElement="arrOfOrder"
          :sortSpacing="3"
          :isShowFilter="false"
          class="card mx-2 mt-4"
          :isDraggable="true"
          @updateFinalData="updateFinalData"
        >
          <template #header-actions>
            <p class="mb-0 mt-3 mx-2">{{$t('OrderCurrent.count')}} {{arrOfOrder.length}}</p>
          </template>
  
          <template #body-content-desktop="content">
            <!-- List of orders -->
            <!-- :key="'order' + index"> -->
            <tr v-for="(order, index) in content.results"
            class="table-element_hover text-center draggable-item"
            :id="'order' + index"
            :key="order.orderNumber">
              <td><i class="mx-2 fa fa-solid fa-bars drag-handle" /></td>
              <td v-if="checkHistory(order.historySync)"> <button class="btn btn-kne-green" :id="'dropDate' + order[index]"><i class="fa fa-solid fa-calendar-check" /></button> </td>
              <td v-else> <button class="btn btn-kne-red" @click="onChangeDropDate(order); setFeedbackMessage('')"><i class="fa fa-solid fa-calendar" /> {{$t('DeliveryLocationModal.drop_date_button')}}</button> </td>
              <td>
                <button class="btn btn-kne-orange" @click="onChangeAddress(order)"><i class="fas fa-edit" /> {{$t('DeliveryLocationModal.address_button')}}</button>
              </td>
              <td v-if="isOrderNbClickable">
                <strong
                    @click="onOrderNumberView()">
                  <router-link :to="{
                    name: 'OrderInfo',
                    query: {orderId: order.orderNumber}}"
                    target="_blank">
                    {{order.orderNumber}}
                  </router-link>
                </strong>
              </td>
              <td v-else>
                {{order.orderNumber}}
              </td>
              <td>
                <span class="nowrap table-fix-width">{{shortenString($realName(order, 'transmitter'))}}
                  <hover-tool-tip
                    :text="`${order.transmitterAddress}
                            ${order.transmitterCity},
                            ${order.transmitterProvince}
                            ${order.transmitterPostcode},
                            ${order.transmitterCountry}`"
                    :top="true"
                    :right="true"
                    :clickable="true"
                  />
                </span>
              </td>
              <td>
                <span class="nowrap table-fix-width">{{shortenString($realName(order, 'receiver'))}}
                  <hover-tool-tip
                    :text="`${order.receiverAddress}
                            ${order.receiverCity},
                            ${order.receiverProvince}
                            ${order.receiverPostcode},
                            ${order.receiverCountry}`"
                    :top="true"
                    :left="true"
                    clickable
                  />
                </span>
              </td>
              <td>
                <regular-input-number
                min="0"
                :value="order.recommendedPrice"
                @input="order.recommendedPrice = $event"
                type="number" :placeholder="`${$t('Marketplace.recommendedPrice')}`"/>
              </td>
              <td>
                <regular-input
                min="0"
                :value="order.numRef"
                @input="order.numRef = $event"
                type="text" :placeholder="$t('OrderInfo.modal.reference')"/>
              </td>
              <td>
                <regular-input
                :value="order.comment"
                @input="order.comment = $event"
                type="text" :placeholder="$t('OrderCurrent.taxescomment')"/>
              </td>
            </tr>
          </template>
  
          <template #body-content-mobile="content">
            <!-- List of orders -->
            <div v-for="(order, index) in content.results"
            class="card my-3 mx-2 draggable-item"
            :key="order.orderNumber">
              <div class="card-header">
                <h4 v-if="isOrderNbClickable">
                  <strong
                  @click="onOrderNumberView()">
                  <router-link :to="{
                    name: 'OrderInfo',
                    query: {orderId: order.orderNumber}}"
                    target="_blank">
                    {{order.orderNumber}}
                  </router-link>
                </strong>
              </h4>
              <h4 v-else>
                {{order.orderNumber}}
              </h4>
  
                <div id="action" class="float-left">
                  <p v-if="checkHistory(order.historySync)" class=""> <button class="btn btn-kne-green" :id="'dropDate' + order[index]"><i class="fa fa-solid fa-calendar-check" /></button> </p>
                  <p v-else class=""> <button class="btn btn-kne-red" @click="onChangeDropDate(order)"><i class="fa fa-solid fa-calendar" /> {{$t('DeliveryLocationModal.drop_date_button')}}</button> </p>
                  <button class="btn btn-kne-orange mx-1" @click="onChangeAddress(order)"><i class="fas fa-edit" /> {{$t('DeliveryLocationModal.address_button')}}</button>
                </div>
              </div>
  
              <div>
                <p class="m-2">
                  <span class="nowrap table-fix-width">{{shortenString($realName(order, 'transmitter'))}}
                    <hover-tool-tip
                      :text="`${order.transmitterAddress}
                              ${order.transmitterCity},
                              ${order.transmitterProvince}
                              ${order.transmitterPostcode},
                              ${order.transmitterCountry}`"
                      :top="true"
                      :right="true"
                      :clickable="true"
                    />
                  </span>
                </p>
                <p class="m-2">
                  <span class="nowrap table-fix-width">{{shortenString($realName(order, 'receiver'))}}
                    <hover-tool-tip
                      :text="`${order.receiverAddress}
                              ${order.receiverCity},
                              ${order.receiverProvince}
                              ${order.receiverPostcode},
                              ${order.receiverCountry}`"
                      :top="true"
                      :left="true"
                      clickable
                    />
                  </span>
                </p>
                
                <p class="m-2">
                  <regular-input
                  min="0"
                  :value="order.recommendedPrice"
                  @input="order.recommendedPrice = $event;"
                  type="number" :placeholder="`${$t('Marketplace.recommendedPrice')}`"/>
                </p>
                <p class="m-2">
                  <regular-input
                  min="0"
                  :value="order.numRef"
                  @input="order.numRef = $event; "
                  type="text" :placeholder="$t('OrderInfo.modal.reference')"/>
                </p>
                <p class="m-2">
                  <regular-input
                  :value="order.comment"
                  @input="order.comment = $event"
                  type="text" :placeholder="$t('OrderCurrent.taxescomment')"/>
                </p>
                <div class="d-flex justify-content-center my-3">
                  <i class="mx-2 fa fa-solid fa-bars drag-handle" />
                </div>
              </div>
            </div>
            
          </template>
  
          <template #post-body-content>
            <div class="mt-2">
              <p class="red-text mb-0 mx-1 text-right">{{ feedbackMessage }}</p>
              <button
                class="float-right btn btn-kne-orange m-1"
                @click="onCreateOfferActionConfirm()">
                {{$t('OrderCurrent.modal.confirm')}}
              </button>
              <button @click="reinitializeModal()" class="float-right btn btn-danger m-1">{{$t('OrderCurrent.modal.cancel')}}</button>
            </div>
          </template>
        </table-element>
  
        <loading-render v-if="isLoading" />
      </modal>
  
      <!-- Distributed History -->
      <distributed-history-modal
        key="distributed"
        ref="distModal"
        :isOpen="isDistributedModal"
        :priceOrderLink="priceOrderLink"
        @updateOrderInSelectedFull="(orderId, historyKey, order) => updateOrderInSelectedFull(orderId, historyKey, order)"
        @closeModal="isDistributedModal = false"
      />

      <!-- Delivery Location -->
      <delivery-location-modal
        ref="delivLocDetails"
        :addressbook="addressbook"
        :showBilling="false"
        :isOpen="isDelivLocModal"
        @emitNewOrderLocation="updateOrderLocation"
        @closeModal="isDelivLocModal = false"
      />
    </div>
</template>
  
<script>
import Modal from '../../interface-components/Modal.vue'
import regularSelect from '../../../module/basic-components/regularSelect.vue'
import regularInput from '../../basic-components/regularInput.vue'
import regularInputNumber from '../../basic-components/regularInputNumber.vue'
import regularDatalistDriver from '../../basic-components/regularDatalistDriver.vue'
import hoverToolTip from '../../basic-components/hoverToolTip.vue'
import DistributedHistoryModal from './DistributedHistory-modal.vue'
import DeliveryLocationModal from './DeliveryLocation-modal.vue'
import TableElement from '../Table-component/Table-Element.vue'
import LoadingRender from '../Other-components/LoadingRender.vue'
import { db } from '../../../../firebase'

export default {
    name: 'CreateOfferModal',
    components: {
        Modal,
        regularInput,
        regularSelect,
        regularInputNumber,
        regularDatalistDriver,
        hoverToolTip,
        DistributedHistoryModal,
        DeliveryLocationModal,
        TableElement,
        LoadingRender
    },

    props: {
        arrOfOrder: {
          type: Array,
          required: true
        },
        liste: {
          type: Array,
          required: true
        },
        addressbook: {
          type: Array,
          required: true
        },
        priceOrderLink: {
          type: Array,
          required: true
        },
        isOrderNbClickable: {
          type: Boolean,
          required: false,
          default: true
        },
        isOpen: Boolean
    },

    data () {
        return {
            finalData: this.arrOfOrder.slice().reverse(),
            marketplaceOffer: {},
            feedbackMessage: '',
            isDelivLocModal: false,
            isDistributedModal: false,
            recommendedPrice: '',
            fieldsObj: [
                {
                    text: this.$t('OrderCurrent.order'),
                    type: 'orderNumber',
                    value: ''
                },
                {
                    text: this.$t('OrderInfo.modal.pickup.title'),
                    type: 'transmitterName',
                    value: ''
                },
                {
                    text: this.$t('OrderInfo.modal.delivery.title'),
                    type: 'receiverName',
                    value: ''
                },
                {
                    text: this.$t('Marketplace.recommendedPrice'),
                    type: 'recommendedPrice',
                    value: ''
                },
                {
                    text: this.$t('OrderInfo.modal.reference'),
                    type: 'numRef',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.taxescomment'),
                    type: 'comment',
                    value: ''
                }
            ],
            transporters: []
        }
    },

    created () {
        this.isLoading = false
        // Add default recommended price for each order
        this.finalData = this.finalData.map(item => {
                item.recommendedPrice = item.price
                return item
            })
    },

    methods: {
        updateFinalData (newData) {
            this.finalData = [...newData]
        },
        onOrderNumberView () {
            this.setFeedbackMessage(this.$t('ShortDispatch.reopen_window_alert'))
        },

        /** When the user wants to change the address, set the order with the @ref */
        onChangeAddress (order) {
            const delivRef = this.$refs.delivLocDetails

            delivRef.setOrder(order)
            this.isDelivLocModal = true
        },

        /** Updates the location of an order in the @arrOfOrder array after the user changes and saves the location in DeliveryLocationModal */
        updateOrderLocation (updatedOrder, isApplyToAllTransmitter, isApplyToAllReceiver) {
            if (isApplyToAllTransmitter) { // If the user applies the location changes of an order to all orders in the array
                this.arrOfOrder.forEach(order => {
                order.transmitterName = updatedOrder.transmitterName
                this.$set(order, 'realTransmitterName', updatedOrder.realTransmitterName || null)
                this.$set(order, 'differentTransmitter', updatedOrder.differentTransmitter || null)
                order.transmitterAddress = updatedOrder.transmitterAddress
                order.transmitterPostcode = updatedOrder.transmitterPostcode
                order.transmitterCity = updatedOrder.transmitterCity
                order.transmitterProvince = updatedOrder.transmitterProvince
                order.transmitterCountry = updatedOrder.transmitterCountry
                })
            }

            if (isApplyToAllReceiver) {
                this.arrOfOrder.forEach(order => {
                order.receiverName = updatedOrder.receiverName
                this.$set(order, 'realReceiverName', updatedOrder.realReceiverName || null)
                this.$set(order, 'differentReceiver', updatedOrder.differentReceiver || null)
                order.receiverAddress = updatedOrder.receiverAddress
                order.receiverPostcode = updatedOrder.receiverPostcode
                order.receiverCity = updatedOrder.receiverCity
                order.receiverProvince = updatedOrder.receiverProvince
                order.receiverCountry = updatedOrder.receiverCountry
                })
            }

            let indexOfOrder = this.arrOfOrder.findIndex(originalOrder => (originalOrder.orderNumber || originalOrder['.key']) === updatedOrder.orderNumber || updatedOrder['.key'])
            const orderToUpdate = { ...updatedOrder }
            delete orderToUpdate['.key']

            db.ref().child('database').child('transporter').child(this.companyUID).child('deliveries').child(updatedOrder.orderNumber).set(orderToUpdate)
                .then(() => {
                console.log('success')
                })
                .catch(function (error) {
                console.log(error)
                })
            this.$set(this.arrOfOrder, indexOfOrder, updatedOrder)
        },

        /** When @dropDate or @isCancelled doesn't exist in the last history key, allow the user to set the @dropDate or @isCancelled to the last history key */
        onChangeDropDate (order) {
          const distModalRef = this.$refs.distModal

          const keys = distModalRef.getObjectKeys(order.historySync)
          const lastKey = distModalRef.getLastArrayData(keys)

          distModalRef.setOrder(order)
          distModalRef.setOrderId(order.orderNumber)
          distModalRef.setHistoryKey(lastKey)

          this.isDistributedModal = true
        },

        /** Used to set the red (false) or green (true) buttons in Short Dispatch */
        checkHistory (history) {
          const isTruthy = this.$refs.distModal.checkHistory(history)
          return isTruthy
        },

        updateOrderInSelectedFull (orderId, historyKey, updatedOrder) {
            this.arrOfOrder.find((originalOrder, index) => {
                if (originalOrder.orderNumber === orderId) {
                this.arrOfOrder[index].historySync[historyKey] = updatedOrder
                }
            })
        },

        setFeedbackMessage (message) {
            this.feedbackMessage = message
        },

        onCreateOfferActionConfirm () {
          const isAlreadyOffer = this.finalData.filter(order => order.isMarketplaceOffer)
          if (isAlreadyOffer.length !== 0) {
            this.setFeedbackMessage(this.$t('Marketplace.previousOfferPresent'))
            return
          }

          if (!this.isDropDateFilled()) { // Drop date has to be filled (Green display, by setting a date or selecting "Cancelled order")
            this.setFeedbackMessage(this.$t('OrderCurrent.modal.short_dispatch.drop_date_error'))
            return
          }

          const missingRecommendedPrice = this.finalData.filter(order => !order.recommendedPrice)
          if (missingRecommendedPrice.length !== 0) {
              this.setFeedbackMessage(this.$t('Marketplace.missingRecommendedPrice'))
              return
          }

          this.createOfferAction()
        },

        createOfferAction () {
            this.finalData.forEach((order, index) => {
                let orderNumber = order.orderNumber
                delete order.orderNumber

                let marketplaceOffer = {
                    id: order.transpCigle + orderNumber,
                    dateCreated: Date.now(),
                    infos: {
                        billNum: order.billNum,
                        creationDate: order.creationDate,
                        dateSignataire: order.dateSignataire,
                        make: order.make,
                        model: order.model,
                        price: order.price,
                        receiver: order.receiver,
                        receiverAddress: order.receiverAddress,
                        receiverCity: order.receiverCity,
                        receiverContact: order.receiverContact,
                        receiverCountry: order.receiverCountry,
                        receiverEmail: order.receiverEmail,
                        receiverFax: order.receiverFax,
                        receiverLat: order.receiverLat,
                        receiverLong: order.receiverLong,
                        receiverName: order.receiverName,
                        receiverPhone: order.receiverName,
                        receiverPlaceId: order.receiverPlaceId,
                        receiverPostcode: order.receiverPostcode,
                        receiverProvince: order.receiverProvince,
                        regularPrice: order.regularPrice,
                        size: order.size,
                        source: order.source,
                        transmitter: order.transmitter,
                        transmitterAddress: order.transmitterAddress,
                        transmitterCity: order.transmitterCity,
                        transmitterContact: order.transmitterContact,
                        transmitterCountry: order.transmitterCountry,
                        transmitterEmail: order.transmitterEmail,
                        transmitterFax: order.transmitterFax,
                        transmitterLat: order.transmitterLat,
                        transmitterLong: order.transmitterLong,
                        transmitterName: order.transmitterName,
                        transmitterPhone: order.transmitterPhone,
                        transmitterPlaceId: order.transmitterPlaceId,
                        transmitterPostcode: order.transmitterPostcode,
                        transmitterProvince: order.transmitterProvince,
                        transpCigle: order.transpCigle,
                        transpName: order.transpName,
                        trim: order.trim,
                        vin: order.vin,
                        weight: order.weight,
                        year: order.year
                    },
                    provider: this.companyUID,
                    recommendedPrice: order.recommendedPrice,
                    comment: order.comment,
                    status: 'ACTIVE'
                }

                this.dbPushSet(marketplaceOffer, orderNumber)
            })

            this.clearSelected()
            this.reinitializeModal()
        },

        async dbPushSet (marketplaceOffer, orderNumber) {
            console.log({marketplaceOffer})
            db.ref().child('database').child('transporter').child(this.companyUID).child('deliveries').child(orderNumber).child('isMarketplaceOffer').set(true)
              .then(() => {
              console.log('success')
              })
              .catch(function (error) {
              console.log(error)
              })
            const newOfferRef = db.ref().child('database').child('offers').push()
            await newOfferRef.set(marketplaceOffer)
            const pushId = newOfferRef.key

            // Fetching Transporter data to set notifications for all
            const transporterData = await db.ref('userInfos').once('value')
            let transporters = transporterData.val() ? Object.keys(transporterData.val()) : []
            transporters = transporters.filter((id) => {
              return id !== this.companyUID
            })
            transporters.forEach(id => {
              db.ref().child('database').child('transporter').child(id).child('alerts').child('marketplace').child(pushId).child('newOffer').set(true)
                .then(() => {
                  console.log('success')
                })
                .catch(function (error) {
                  console.log(error)
                })
            })
        },

        shortenString (text) {
            if (typeof text === 'undefined') return text
            else {
                let subString = text.substring(0, 22)
                if (text.length > 22) subString += '...'
                return subString
            }
        },

        isDropDateFilled () {
          let isGucci = true

          this.arrOfOrder.forEach(order => {
            if (!this.checkHistory(order.historySync)) isGucci = false
          })

          return isGucci
        },

        reinitializeModal () {
            this.feedbackMessage = ''

            this.closeModal()
        },

        clearSelected () {
            this.$emit('clearSelected')
        },
        closeModal () {
            this.$emit('closeModal')
        }
    },
    computed: {
        companyUID () {
            return this.$store.state.authorization.company
        },

        uid () {
            return this.$store.state.user.uid
        }
    }
}
</script>
  
<style scoped>
</style>
